import { render, staticRenderFns } from "./LimitedSpecial.vue?vue&type=template&id=5bbfec4e&scoped=true"
import script from "./LimitedSpecial.vue?vue&type=script&lang=js"
export * from "./LimitedSpecial.vue?vue&type=script&lang=js"
import style0 from "./LimitedSpecial.vue?vue&type=style&index=0&id=5bbfec4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbfec4e",
  null
  
)

export default component.exports